import RoomsCatalog from './RoomsCatalog'
import './RoomsCatalog.css'
import './background.css'

export default RoomsCatalog



// WEBPACK FOOTER //
// ./src/components/RoomsCatalog/index.js